import React from "react";
import ReactDOM from "react-dom/client";
import { GoogleOAuthProvider } from "@react-oauth/google";
import "./index.css";
import App from "./App";
import "./App.css";
import reportWebVitals from "./reportWebVitals";

const GOOGLE_CLIENT_ID = "532281099320-6jd418d408vvh6dqalogn53b1d7eqq65.apps.googleusercontent.com"; // Replace with actual Client ID

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
    <App />
  </GoogleOAuthProvider>
);

document.head.appendChild(Object.assign(document.createElement("meta"), {
  httpEquiv: "Cross-Origin-Opener-Policy",
  content: "same-origin-allow-popups"
}));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

